import { Icon } from "@chakra-ui/react";

const TicketMonoIcon = (props: any) => (
  <Icon viewBox="0 0 20 20" fill="none" {...props}>
    <g id="Group">
      <path
        id="Vector"
        d="M9.58309 18.879C9.70879 18.9687 9.86226 19.0107 10.0161 18.9977C10.1699 18.9847 10.3142 18.9174 10.423 18.8079L18.8067 10.4233C18.9161 10.3144 18.9832 10.1702 18.9963 10.0164C19.0093 9.86265 18.9674 9.70921 18.8779 9.58345C18.4853 9.03105 18.2744 8.37017 18.2744 7.69249C18.2744 7.01481 18.4853 6.35393 18.8779 5.80153C18.9677 5.67576 19.0099 5.52212 18.9969 5.3681C18.9838 5.21408 18.9164 5.06972 18.8067 4.96084L15.0392 1.19253C14.9302 1.08274 14.7857 1.0153 14.6315 1.00226C14.4774 0.989219 14.3236 1.03143 14.1977 1.12134C13.6454 1.51372 12.9846 1.72452 12.3071 1.72452C11.6296 1.72452 10.9689 1.51372 10.4166 1.12134C10.2908 1.03201 10.1374 0.990151 9.9836 1.00318C9.82984 1.01622 9.68568 1.0833 9.57669 1.19253L1.19297 9.57705C1.08362 9.68594 1.01639 9.83005 1.00321 9.98381C0.99003 10.1376 1.03176 10.291 1.12098 10.4169C1.51354 10.9693 1.72445 11.6302 1.72445 12.3079C1.72445 12.9856 1.51354 13.6464 1.12098 14.1988C1.03123 14.3247 0.989186 14.4784 1.00238 14.6324C1.01556 14.7865 1.08313 14.9308 1.19297 15.0395L4.96048 18.8079C5.06951 18.9171 5.21382 18.9841 5.36765 18.9969C5.52149 19.0096 5.67485 18.9673 5.80038 18.8774C6.35302 18.4849 7.01414 18.2742 7.69199 18.2745C8.36983 18.2748 9.03078 18.4861 9.58309 18.879Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="Vector_2"
        d="M10.4609 3.99976L15.9994 9.53823L9.53786 15.9998L3.99938 10.4613L10.4609 3.99976Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="Vector_3"
        d="M10.4616 7.69244L7.69238 10.4617"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        id="Vector_4"
        d="M11.4228 10.4233L10.5605 11.2856"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
  </Icon>
);

export default TicketMonoIcon;
